// @deprecated
export default function () {
	//validator only for ReplyForm!
	//don't use it in another forms
	Nette.validators.JenPraceModulesFrontFormsValidatorsCvValidatorRule_validateCv = (elem, args, val) => {
		// Checkboxy s přílohami
		const attachmentsList = elem.closest('form').querySelectorAll('.attachments input[type=checkbox]');
		// Upload políčka
		const fileUploadInputs = elem.closest('form').querySelectorAll('.jp-upload input[type=file]');

		let cvNotEmpty = false;
		attachmentsList.forEach(function (el) {
			console.log(el);
			//first control checkbox attachments
			if (el.checked === true && cvNotEmpty === false) {
				cvNotEmpty = true;
			}
		});

		if (cvNotEmpty === false) {
			// if checkbox attachments is empty, then control uploads
			fileUploadInputs.forEach(function (el) {
				console.log(el.value);
				if (el.value) {
					cvNotEmpty = true;
				}
			});
		}

		return cvNotEmpty;
	};
}
